import React, { useEffect, useState } from 'react';
import { Typography, Button, TextField, MenuItem } from '@material-ui/core';
import { Formik } from 'formik';
import { css } from '@emotion/core';
import { useHistory } from 'react-router-dom';
import SimpleSelect from '../util/SimpleSelect';
import { useRootStore } from '../../stores/BridgeProvider';
import { ErrorText, FlexDiv, WideBox, StyledForm } from '../styles/styles';
import Spinner from '../util/Spinner';
import { safeEval, safeFalsy } from '../util/UtilFunctions';
import AccountSelect from '../util/AccountSelect';

const PaymentTypeForm = ({ onSubmit, paymentType = {} }) => {
  const { dataStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const history = useHistory();
  const accounts = dataStore.validAccountArray;
  const fetchAccounts = async () => {
    if (accounts.length === 0) {
      await dataStore.retrieveAccounts();
    }
  };
  useEffect(() => {
    const initialize = async () => {
      await fetchAccounts();
      setLoading(false);
    };
    initialize();
  }, []);

  if (isLoading || !paymentType) return <Spinner />;

  return (
    <Formik
      initialValues={{
        PaymentTypeId: safeFalsy(paymentType.PaymentTypeId),
        TranType: safeFalsy(paymentType.TranType),
        PaymentTypeName: safeFalsy(paymentType.PaymentTypeName),
        AccountId: safeFalsy(paymentType.AccountId),
        Account: dataStore.getAccountFromId(paymentType.AccountId),
        SortOrder: 1,
      }}
      onSubmit={async (values, actions) => {
        await onSubmit(values);
        actions.setSubmitting(false);
      }}
      render={({
        handleBlur,
        handleChange,
        errors,
        handleSubmit,
        values,
        isSubmitting,
        setFieldValue,
      }) => {
        const showError = val => errors[val] && touched[val];
        const isValidAccountGroup = TypeId => ![1, 2].includes(TypeId);

        const moveAccountTypeToFront = (list, typeId) => {
          const index = list.findIndex(({ id }) => id === typeId);
          list.splice(0, 0, list.splice(index, 1)[0]);
          return list;
        };
        return (
          <FlexDiv>
            <WideBox showoverflow={1} style={{ justifyContent: 'center' }}>
              <Typography variant="h2" gutterBottom>
                {paymentType.PaymentTypeId
                  ? 'Edit Payment Type'
                  : 'New Payment Type'}
              </Typography>
              <StyledForm onSubmit={handleSubmit}>
                <TextField
                  className="ptFormField"
                  name="PaymentTypeName"
                  label="Payment Type Name"
                  value={values.PaymentTypeName}
                  margin="normal"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  fullWidth
                  error={errors.PaymentTypeName}
                />
                <SimpleSelect
                  label="Transaction Type *"
                  handleChange={handleChange}
                  value={values.TranType}
                  name="TranType"
                  containerStyle={{ width: '100%' }}
                >
                  <MenuItem value="AP">AP</MenuItem>
                  <MenuItem value="AR">AR</MenuItem>
                </SimpleSelect>
                <div style={{ width: '100%', zIndex: 1000 }}>
                  <AccountSelect
                    placeholder="Account *"
                    value={values.Account}
                    isValidAccountGroup={isValidAccountGroup}
                    sortFunction={list => moveAccountTypeToFront(list, 3)}
                    onChange={val => {
                      setFieldValue('Account', val);
                      setFieldValue(
                        'AccountId',
                        safeEval(() => val.AccountId),
                        null,
                      );
                    }}
                  />
                </div>
                {showError('AccountId') && (
                  <ErrorText>{errors.AccountId}</ErrorText>
                )}

                <div
                  css={css`
                    display: flex;
                    margin-top: 1.2rem;
                    justify-content: flex-end;
                    & > button {
                      margin: 5px;
                    }
                  `}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    size="large"
                    disabled={isSubmitting}
                    style={{
                      margin: '5px',
                    }}
                  >
                    Submit
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="large"
                    onClick={() => history.goBack()}
                    style={{
                      margin: '5px',
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </StyledForm>
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default PaymentTypeForm;
